var _defs, _rect, _g, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafetyFirstFund(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #7499d6;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-4 {\n        fill: #7499d6;\n      }\n\n      .cls-6 {\n        opacity: .39;\n      }\n\n      .cls-3 {\n        fill: #445689;\n      }\n\n      .cls-4 {\n        opacity: .78;\n      }\n\n      .cls-5 {\n        fill: #d0f19a;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 256,
    height: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.19,120.58c-20.78-.27-36.02,8.38-43.15,27.77-7.1,19.32-.92,35.66,14.83,48.81h-90.7v-9.94c0-2.71.02-5.42,0-8.14-.05-5.29-2.97-8.21-8.28-8.31-.81-.02-1.62,0-2.55,0v-19.09c2.54,0,4.93,0,7.32,0,5.55-.02,8.48-2.97,8.49-8.52,0-5.73.02-11.45,0-17.18-.02-5.38-3.02-8.35-8.45-8.35-12.13-.01-24.26,0-36.39,0-.83,0-1.65,0-2.77,0-.04-.81-.1-1.52-.1-2.23,0-6.63-.02-13.26,0-19.89.02-7.72,4.87-12.57,12.57-12.57,45.58,0,91.16,0,136.75,0,7.47,0,12.38,4.83,12.41,12.25.04,8.43,0,16.86,0,25.41ZM125.69,167.29v-20.88h20.7v-12.59h-20.79v-20.8h-12.64v20.95h-20.7v12.58h20.75c0,3.63,0,7.01,0,10.38s0,6.87,0,10.36h12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.39,197.29c-19.4-.14-34.73-15.6-34.59-34.88.14-19.09,15.81-34.48,34.97-34.33,19.06.14,34.43,15.87,34.24,35.05-.19,18.94-15.75,34.3-34.61,34.16ZM207.86,154.54c-.03-3.83-2.45-7.54-6.12-9.68-.69-.4-1.39-1.28-1.53-2.04-.44-2.31-1.72-3.8-3.71-3.86-2.05-.06-3.46,1.46-3.91,3.89-.13.71-.73,1.57-1.36,1.93-4.83,2.78-7.12,7.53-5.98,12.72,1.11,5.08,5.32,8.57,10.81,8.96,2.73.2,4.26,1.61,4.27,3.96.01,2.09-1.48,3.77-3.54,3.99-2.23.24-3.92-1.28-4.33-3.89-.42-2.67-2.1-4.09-4.41-3.71-2.14.35-3.41,2.26-3.07,4.75.54,3.99,2.51,7.07,6.12,8.93,1.06.54,1.52,1.09,1.61,2.35.16,2.32,1.75,3.65,3.84,3.58,1.98-.07,3.23-1.44,3.65-3.63.15-.79.72-1.76,1.39-2.14,4.64-2.67,7.05-7.4,6.07-12.28-1.04-5.24-4.95-8.72-10.49-9.34-3.28-.37-4.71-1.59-4.71-4.02,0-2.09,1.53-3.77,3.58-3.94,2.4-.2,3.69,1.09,4.37,4.34.46,2.21,2.15,3.56,4.14,3.31,2.01-.25,3.33-1.91,3.31-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.83,75.38h-9.45v-7.72h-47.87v7.65h-9.39c0-3.47-.46-7.04.12-10.43.71-4.19,4.58-6.96,8.87-6.97,16.19-.05,32.38-.06,48.57,0,4.82.02,8.82,3.84,9.12,8.62.18,2.9.03,5.82.03,8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.14,75.37c-.82-4.97,1.59-7.89,6.42-7.91,3.92-.02,7.84-.02,11.75,0,4.82.03,7.22,3.01,6.29,7.91h-24.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M161.01,75.31c-.7-5.17,1.61-7.85,6.68-7.86,3.68,0,7.37,0,11.05,0,5.12,0,7.31,2.46,6.85,7.85h-24.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.69,167.29h-12.68c0-3.49,0-6.93,0-10.36s0-6.75,0-10.38h-20.75v-12.58h20.7v-20.95h12.64v20.8h20.79v12.59h-20.7v20.88Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 195.99,
    cy: 162.26,
    r: 31.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.56,148.84h-21.26v4.04h7.51c2.79.46,4.88,1.59,5.74,3.09h-13.24v4.04h12.97c-.14.2-.31.38-.5.55-2.29,2.08-7.06,2.17-11.35,2.1h-.38s0,2.78,0,2.78l14.2,14.27h5.71l-13.14-13.21c2.47-.28,5.55-1.03,7.66-2.94,1.08-.98,1.83-2.17,2.22-3.55h3.86v-4.04h-3.72c-.25-1.13-.76-2.16-1.52-3.09h5.24v-4.04Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 37,
    y: 124,
    width: 43,
    height: 14,
    rx: 2.71,
    ry: 2.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 37,
    y: 181,
    width: 41,
    height: 16,
    rx: 2.71,
    ry: 2.71
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 30,
    y: 141,
    width: 36,
    height: 9,
    rx: 3.15,
    ry: 3.15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 30,
    y: 154,
    width: 36,
    height: 9,
    rx: 3.15,
    ry: 3.15
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 30,
    y: 167,
    width: 36,
    height: 9,
    rx: 3.15,
    ry: 3.15
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43,
    y1: 124,
    x2: 43,
    y2: 127.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.5,
    y1: 124,
    x2: 47.5,
    y2: 127.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52,
    y1: 124,
    x2: 52,
    y2: 127.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.5,
    y1: 124,
    x2: 56.5,
    y2: 127.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61,
    y1: 124,
    x2: 61,
    y2: 127.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.5,
    y1: 124,
    x2: 65.5,
    y2: 127.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 70,
    y1: 124,
    x2: 70,
    y2: 127.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.5,
    y1: 124,
    x2: 74.5,
    y2: 127.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43,
    y1: 127.82,
    x2: 43,
    y2: 138
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.5,
    y1: 127.82,
    x2: 47.5,
    y2: 138
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52,
    y1: 127.82,
    x2: 52,
    y2: 138
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.5,
    y1: 127.82,
    x2: 56.5,
    y2: 138
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61,
    y1: 127.82,
    x2: 61,
    y2: 138
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.5,
    y1: 127.82,
    x2: 65.5,
    y2: 138
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 70,
    y1: 127.82,
    x2: 70,
    y2: 138
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.5,
    y1: 127.82,
    x2: 74.5,
    y2: 138
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43,
    y1: 181,
    x2: 43,
    y2: 185.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.5,
    y1: 181,
    x2: 47.5,
    y2: 185.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52,
    y1: 181,
    x2: 52,
    y2: 185.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.5,
    y1: 181,
    x2: 56.5,
    y2: 185.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61,
    y1: 181,
    x2: 61,
    y2: 185.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.5,
    y1: 181,
    x2: 65.5,
    y2: 185.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 70,
    y1: 181,
    x2: 70,
    y2: 185.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.5,
    y1: 181,
    x2: 74.5,
    y2: 185.36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43,
    y1: 185.36,
    x2: 43,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.5,
    y1: 185.36,
    x2: 47.5,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52,
    y1: 185.36,
    x2: 52,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.5,
    y1: 185.36,
    x2: 56.5,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61,
    y1: 185.36,
    x2: 61,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.5,
    y1: 185.36,
    x2: 65.5,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 70,
    y1: 185.36,
    x2: 70,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.5,
    y1: 185.36,
    x2: 74.5,
    y2: 197
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.5,
    y1: 141,
    x2: 36.5,
    y2: 143.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41,
    y1: 141,
    x2: 41,
    y2: 143.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.5,
    y1: 141,
    x2: 45.5,
    y2: 143.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50,
    y1: 141,
    x2: 50,
    y2: 143.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.5,
    y1: 141,
    x2: 54.5,
    y2: 143.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59,
    y1: 141,
    x2: 59,
    y2: 143.45
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.5,
    y1: 143.45,
    x2: 36.5,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41,
    y1: 143.45,
    x2: 41,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.5,
    y1: 143.45,
    x2: 45.5,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50,
    y1: 143.45,
    x2: 50,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.5,
    y1: 143.45,
    x2: 54.5,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59,
    y1: 143.45,
    x2: 59,
    y2: 150
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.5,
    y1: 154,
    x2: 36.5,
    y2: 156.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41,
    y1: 154,
    x2: 41,
    y2: 156.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.5,
    y1: 154,
    x2: 45.5,
    y2: 156.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50,
    y1: 154,
    x2: 50,
    y2: 156.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.5,
    y1: 154,
    x2: 54.5,
    y2: 156.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59,
    y1: 154,
    x2: 59,
    y2: 156.45
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.5,
    y1: 156.45,
    x2: 36.5,
    y2: 163
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41,
    y1: 156.45,
    x2: 41,
    y2: 163
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.5,
    y1: 156.45,
    x2: 45.5,
    y2: 163
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50,
    y1: 156.45,
    x2: 50,
    y2: 163
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.5,
    y1: 156.45,
    x2: 54.5,
    y2: 163
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59,
    y1: 156.45,
    x2: 59,
    y2: 163
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.5,
    y1: 167,
    x2: 36.5,
    y2: 169.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41,
    y1: 167,
    x2: 41,
    y2: 169.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.5,
    y1: 167,
    x2: 45.5,
    y2: 169.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50,
    y1: 167,
    x2: 50,
    y2: 169.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.5,
    y1: 167,
    x2: 54.5,
    y2: 169.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59,
    y1: 167,
    x2: 59,
    y2: 169.45
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.5,
    y1: 169.45,
    x2: 36.5,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41,
    y1: 169.45,
    x2: 41,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.5,
    y1: 169.45,
    x2: 45.5,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50,
    y1: 169.45,
    x2: 50,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.5,
    y1: 169.45,
    x2: 54.5,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59,
    y1: 169.45,
    x2: 59,
    y2: 176
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75,
    cy: 184,
    r: 13,
    transform: "translate(-31.65 16.35) rotate(-10.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 75,
    cy: 184,
    r: 12.56,
    transform: "translate(-117.7 232.46) rotate(-81.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.72,181.98s-.1.02-.15,0c-.17-.04-.28-.2-.25-.38.91-4.44,4.19-7.93,8.56-9.11.7-.19,1.41-.32,2.13-.38.18-.02.33.12.35.29.01.18-.11.33-.29.35-.68.06-1.35.18-2.01.36-4.13,1.12-7.24,4.43-8.1,8.62-.03.12-.12.21-.23.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 75.34,
    cy: 184.19,
    r: 10.63,
    transform: "translate(-70.96 49.28) rotate(-25.07)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.89,179.05h-9.27v1.76h3.27c1.22.2,2.13.69,2.5,1.35h-5.78v1.76h5.66c-.06.09-.14.17-.22.24-1,.91-3.08.95-4.95.92h-.17s0,1.21,0,1.21l6.19,6.22h2.49l-5.73-5.76c1.08-.12,2.42-.45,3.34-1.28.47-.43.8-.95.97-1.55h1.68v-1.76h-1.62c-.11-.49-.33-.94-.66-1.35h2.28v-1.76Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 65.73,
    cy: 181.74,
    r: 15.26,
    transform: "translate(-31.4 14.66) rotate(-10.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 65.73,
    cy: 181.74,
    r: 14.75,
    transform: "translate(-123.43 221.34) rotate(-81.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.48,179.37c-.05.01-.11.02-.17,0-.2-.04-.33-.24-.29-.44,1.07-5.21,4.92-9.31,10.05-10.7.82-.22,1.66-.37,2.5-.44.21-.02.39.14.41.34.02.21-.13.39-.34.41-.79.07-1.59.21-2.36.42-4.85,1.32-8.5,5.2-9.51,10.12-.03.14-.14.25-.27.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 66.12,
    cy: 181.97,
    r: 12.48,
    transform: "translate(-70.88 45.17) rotate(-25.07)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.3,175.92h-10.89v2.07h3.84c1.43.23,2.5.82,2.94,1.58h-6.78v2.07h6.64c-.07.1-.16.19-.26.28-1.17,1.06-3.62,1.11-5.81,1.08h-.19s0,1.42,0,1.42l7.27,7.31h2.93l-6.73-6.76c1.26-.14,2.84-.53,3.92-1.5.56-.5.94-1.11,1.14-1.82h1.98v-2.07h-1.91c-.13-.58-.39-1.11-.78-1.58h2.68v-2.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyFirstFund);
export default __webpack_public_path__ + "static/media/Safety-first Fund.612cf0db16e3d150a68b0a9aa33a239d.svg";
export { ForwardRef as ReactComponent };